import lodash from 'lodash';
import { Pagination, Spin } from 'antd';
import { EditableContext } from '../../common/EditableContextProvider';
import { useContext } from 'react';

const MarcaList = ({items, managed}) => {
    const { context } = useContext(EditableContext);

    const handleChange = (e) => {
        context.fillItems(e);
    }

    return (
        <div className="p-3 col-md-9 mx-auto">
            <div className="row">
                { context.loading.items ? (<div className='text-center'><Spin className='me-2' />Cargando...</div>) : '' }
                {
                    context.items?.data?.map((i) => {
                        return (
                            <div className="col-md-6" key={i.id} >
                                <div className='position-relative border rounded m-1 pb-3'>
                                    { (managed === 'true') ? (
                                        <div className='position-absolute top-0 start-0 p-1'>
                                            <button className="btn btn-sm btn-outline-danger px-1 py-0"
                                                title='Eliminar'
                                                onClick={() => context.deleteItem(i.id)}
                                            >
                                                <i className="fas fa-xmark"></i>
                                            </button>
                                            <button className="btn btn-sm btn-outline-secondary ms-1 px-1 py-0"
                                                title='Editar'
                                                onClick={() => context.form.setEditItem(i)}
                                            >
                                                <i className="fas fa-pencil"></i>
                                            </button>
                                        </div>
                                    ) : (<></>) }

                                    <div className="row py-2" style={{ marginRight: '1px', marginBottom: '10px' }} >
                                        <div className="col-12 text-center pt-1">
                                            <p className='fw-bold h5'>
                                                {i.nombre}
                                            </p>
                                        </div>
                                        <div className="col">
                                            <img src={`storage/${i.marca_antigua}`} alt="" className="w-100 rounded mx-1" style={{ maxHeight: '300px',objectFit: 'contain' }} />
                                        </div>
                                        <div className="col">
                                            <img src={`storage/${i.marca_nueva}`} alt="" className="w-100 rounded mx-1" style={{ maxHeight: '300px',objectFit: 'contain' }} />
                                        </div>
                                    </div>

                                    <div className=''>
                                        <div className="row">
                                            <div className="col-6"></div>
                                            <div className="col-6">
                                                <div className="d-flex justify-content-center">
                                                    {
                                                        (i.shop)? (
                                                            <a href={i.shop} className='btn btn-sm p-0 me-1 px-1' title='Shop' target='_blank'>
                                                                <img src="/assets_one/img/marcas/shop1.png" alt="" style={{ height: '20px', width: '20px' }} />
                                                            </a>
                                                        ) : (<></>)
                                                    }
                                                    {
                                                        (i.facebook)? (
                                                            <a href={i.facebook} className='btn btn-sm p-0 me-1 px-1' title='Facebook' target='_blank'>
                                                                <img src="/assets_one/img/marcas/fb1.png" alt="" style={{ height: '20px', width: '20px' }} />
                                                            </a>
                                                        ) : (<></>)
                                                    }
                                                    {
                                                        (i.instagram)? (
                                                            <a href={i.instagram} className='btn btn-sm p-0 me-1 px-1' title='Instagram' target='_blank'>
                                                                <img src="/assets_one/img/marcas/ins1.jpg" alt="" style={{ height: '20px', width: '20px' }} />
                                                            </a>
                                                        ) : (<></>)
                                                    }
                                                    {
                                                        (i.tiktok)? (
                                                            <a href={i.tiktok} className='btn btn-sm p-0 me-1 px-1' title='TikTok' target='_blank'>
                                                                <img src="/assets_one/img/marcas/tik1.png" alt="" style={{ height: '20px', width: '20px' }} />
                                                            </a>
                                                        ) : (<></>)
                                                    }
                                                    {
                                                        (i.whatsapp)? (
                                                            <a href={i.whatsapp} className='btn btn-sm p-0 me-1 px-1' title='Whatsapp' target='_blank'>
                                                                <img src="/assets_one/img/marcas/wpp.png" alt="" style={{ height: '20px', width: '20px' }} />
                                                            </a>
                                                        ) : (<></>)
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })

                }
            </div>
            <Pagination align='center' defaultCurrent={1} total={context.items ? context.items?.total : 0} onChange={handleChange} />
        </div>
    );
}

export default MarcaList;
